import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Badge } from 'react-bootstrap';
import EquipoManual from './EquipoManual';
import EquipoExcel from './EquipoExcel';
import EquipoExistente from './EquipoExistente';
import EquipoUltimasCal from './EquipoUltimasCal';
import { getDataList } from '../../../api/common';

/**
 * EquipoManager - Tab container for equipment input methods
 * @param {Object} props - Component props
 * @param {string} props.clienteId - ID of selected cliente
 * @param {string} props.sedeId - ID of selected sede
 * @param {Function} props.onValidarDuplicados - Handler to validate duplicates
 * @param {Function} props.onResolverItems - Handler to open resolver items modal
 * @param {Function} props.onAgregar - Handler receiving added equipos
 * @param {Array} props.equiposYaAgregados - Array of equipos already added to the OT
 * @param {boolean} props.disabled - Whether tabs should be disabled
 * @param {Array} props.listaSedes - Lista de sedes del cliente para el modal de corrección
 * @param {Function} props.onCorregir - Handler para corregir equipos con datos incompletos
 * @returns {JSX.Element}
 */
const EquipoManager = ({
    clienteId,
    sedeId,
    onValidarDuplicados,
    onResolverItems,
    onResolverDependientes,
    onAgregar,
    equiposYaAgregados = [],
    disabled = false,
    listaSedes = [],
    onCorregir,
    initialEquipos = null,
    onEquiposLoaded = null,
    initialDataUltimasCal = null,
    onUltimasCalLoaded = null,
}) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [ListasedesClient, setListasedesClient] = useState([]);
    const [resumenUltimasCal, setResumenUltimasCal] = useState(null);

    const handleEquiposCreados = () => {
        console.log('🔄 handleEquiposCreados llamado, incrementando refreshTrigger');
        setRefreshTrigger(prev => prev + 1);
    };

    //useEffect para consultar lista de sedes del cliente para el modal de corrección preventiva
    useEffect(() => {
        async function fetchSedes() {
            try {

                const response = await getDataList('Sedes', { 
                conditions: { cliente: clienteId }
            }); 
  
                setListasedesClient(response.data.data);
            }   
            catch (error) {
                console.error('Error al cargar sedes del cliente:', error);
            }
        }

        if (clienteId) {
            fetchSedes();
        }
    }, [clienteId]);

    return (
        <div className="mb-4">
            <h5 className="mb-3">Agregar Equipos</h5>
            <Tabs defaultActiveKey="manual" id="equipo-tabs" className="mb-3">
                <Tab eventKey="manual" title="Manual" disabled={disabled}>
                    <EquipoManual
                        clienteId={clienteId}
                        sedeId={sedeId}
                        onValidarDuplicados={onValidarDuplicados}
                        onAgregar={onAgregar}
                        onEquiposCreados={handleEquiposCreados}
                    />
                </Tab>
                
                <Tab eventKey="excel" title="Cargar Excel" disabled={disabled}>
                    <EquipoExcel
                        clienteId={clienteId}
                        sedeId={sedeId}
                        onValidarDuplicados={onValidarDuplicados}
                        onResolverItems={onResolverItems}
                        onAgregar={onAgregar}
                        onEquiposCreados={handleEquiposCreados}
                    />
                </Tab>
                
                <Tab eventKey="existentes" title="Equipos Existentes" disabled={disabled}>
                    <EquipoExistente
                        clienteId={clienteId}
                        equiposYaAgregados={equiposYaAgregados}
                        onAgregar={onAgregar}
                        onResolverDependientes={onResolverDependientes}
                        refreshTrigger={refreshTrigger}
                        listaSedes={ListasedesClient}
                        onCorregir={onCorregir}
                        initialEquipos={initialEquipos}
                        onEquiposLoaded={onEquiposLoaded}
                    />
                </Tab>

                <Tab
                    eventKey="ultimasCal"
                    title={
                        <span>
                            Últimas Cal.
                            {resumenUltimasCal?.vencidos > 0 && (
                                <Badge bg="danger" className="ms-1">{resumenUltimasCal.vencidos}</Badge>
                            )}
                        </span>
                    }
                    disabled={disabled}
                >
                    <EquipoUltimasCal
                        clienteId={clienteId}
                        equiposYaAgregados={equiposYaAgregados}
                        onAgregar={onAgregar}
                        onResolverDependientes={onResolverDependientes}
                        refreshTrigger={refreshTrigger}
                        listaSedes={ListasedesClient}
                        onCorregir={onCorregir}
                        initialData={initialDataUltimasCal}
                        onDataLoaded={onUltimasCalLoaded}
                        onResumenChange={setResumenUltimasCal}
                    />
                </Tab>
            </Tabs>
        </div>
    );
};

export default EquipoManager;
